export function filterByName({ item }, search) {
  return item.name.toLowerCase().includes(search.toLowerCase())
}
